const AreaClass = function (id, data) {
  const obj = Object.create(data)
  obj.ID = id

  function getId() {
    return obj.ID
  }

  function getName(locale) {
    if (!obj.NOMBRE || !obj.ID) {
      return null
    }

    const name = obj.NOMBRE?.[locale] ?? obj.ID

    return name
  }

  function getDescription(locale) {
    if (!obj.DESCRIPCION) {
      return null
    }

    const description = obj.DESCRIPCION?.[locale] ?? ""

    return description
  }

  function getInfo(locale) {
    if (!obj.INFO) {
      return null
    }

    const info = obj.INFO?.[locale] ?? ""

    return info
  }

  function getImage(assetsUrl = "") {
    if (!obj.IMAGEN) {
      return ""
    }

    return `${assetsUrl}${obj.IMAGEN}`
  }

  function isFirstSteps() {
    if (obj.VISTA_DEFECTO !== "") {
      return false
    }

    return true
  }

  function isConfigurator() {
    if (obj.VISTA_DEFECTO === "") {
      return false
    }

    return true
  }

  function isHomeSteps() {
    if (obj.VISTA_DEFECTO !== "") {
      return false
    }

    return true
  }

  function getHijos() {
    const hijosEntries = Object.entries(obj.HIJOS)

    if (hijosEntries.length <= 0) {
      return null
    }

    return hijosEntries
  }

  function getVariables() {
    return obj.VARIABLES
  }

  function getFirstVariable() {
    const variableEntries = Object.entries(obj.VARIABLES)

    if (!obj.VARIABLES || variableEntries <= 0) {
      return null
    }

    return variableEntries[0]
  }

  function getDefaultView() {
    return obj.VISTA_DEFECTO
  }

  function displayInTab() {
    return obj.EN_TAB
  }

  function isActive() {
    return obj.ACTIVO ?? true
  }

  function getConectorSelectionText(context, lang) {
    let text = false;
    try {
        const currentObj = this?.getVariables?.();
        const currentKey = currentObj && Object.keys(currentObj)[0];
        if(currentKey !== "EV_NUM_CONECTORES") return text
        if (currentObj && currentKey) {
          const currentValue = context?.values?.[currentKey];
          text = currentObj?.[currentKey]?.VALORES?.[currentValue]?.TEXTO_SELECCIONADO?.[lang] || false;
          if(currentValue.includes("DUO") || currentValue.includes("TRIO") || currentValue.includes("CUATRO")){
            if(currentValue.includes("60")){
              text += currentObj?.[currentKey]?.VALORES?.[currentValue]?.TEXTO_SELECCIONADO?.[context?.values.EV_TIPO_CONECTOR_LEFT_SIDE]
            }
            if(currentValue.includes("120180")){
              text += currentObj?.[currentKey]?.VALORES?.[currentValue]?.TEXTO_SELECCIONADO?.[context?.values.EV_TIPO_CONECTOR_LEFT_FRONT]
            }
            if(currentValue.includes("420")){
              if(currentValue.includes("DUO")){
                text += currentObj?.[currentKey]?.VALORES?.[currentValue]?.TEXTO_SELECCIONADO?.[context?.values.EV_TIPO_CONECTOR_LEFT_FRONT]
              }
              if(currentValue.includes("TRIO") || currentValue.includes("CUATRO")){
                text += currentObj?.[currentKey]?.VALORES?.[currentValue]?.TEXTO_SELECCIONADO?.[context?.values.EV_TIPO_CONECTOR_LEFT_FRONT]
                text += " + "
                text += currentObj?.[currentKey]?.VALORES?.[currentValue]?.TEXTO_SELECCIONADO?.[context?.values.EV_TIPO_CONECTOR_LEFT_SIDE]
              }
            }
          }
        }
      } catch (e) {
        text = false;
      }
    return text
  }

  return {
    getId,
    getName,
    getImage,
    getDescription,
    getInfo,
    isFirstStepsArea: isFirstSteps,
    isConfiguratorArea: isConfigurator,
    isHomeStepsArea: isHomeSteps,
    getHijos,
    getVariables,
    getFirstVariable,
    getDefaultView,
    displayInTab,
    isActive,
    getConectorSelectionText
  }
}

export default AreaClass
